import { useCallback } from "react"
import { API_BASE_URL } from "../constants"

export const useCreateOrder = (courseId) => {
    return useCallback(async () => {
        return await fetch(
            `${API_BASE_URL}/courses/${courseId}/create-order`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
            .then((response) => response.json())
            .then((data) => data.order_id)
    }, [courseId])
}